import { apiBaseURL } from '../ProjectConstants';
import handleBackendResponse from '../handleNotifications/handleBackendResponse';

async function handleDelReceipt(receiptId, fetch)  {
 

    const response =  await fetch.delete(`${apiBaseURL}/api/Receipt?id=${receiptId}`)
    //const isDataGood = response?.success && response?.data?.statusCode && response?.success !== 'Invalid Model';
    const isDataGood = handleBackendResponse(response);

    console.log('handleDelReceipt receiptId', receiptId);
    console.log('handleDelReceipt response', response);

    return {
        response,
        isDataGood
    };
}
export default handleDelReceipt;